import React, {useEffect} from 'react';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {InvoiceOrdersGridContextProvider} from '../../components/InvoiceOrdersGridContext';
import InvoiceOrdersGrid from '../../components/InvoiceOrdersGrid';
import FieldTextSearch from '../../components/FieldTextSearch';
import FieldDateRange from '../../components/FieldDateRange';
import PageHeader from '../../../../common/components/ui/PageHeader';
import FiltersBar from '../../../../common/components/ui/FiltersBar';
import ButtonDownload from '../../components/ButtonDownload';
import StatsPanel from '../../components/StatsPanel';
import FooterDivider from "../../../../common/components/ui/FooterDivider";
import FooterLogo from "../../../../common/components/ui/FooterLogo";
import styles from './IvoiceOrders.module.scss';

const InvoiceOrders = () => {
  const {setPageTitle} = useGlobalContext();
  const {setPopupPanelContent, closePopupPanel} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'invoiceOrders-page-header'}
        defaultMessage={'Invoice orders'}
      />
    ));

    return () => {
      closePopupPanel();
      setPopupPanelContent(null);
    };
  }, []);

  return (
    <InvoiceOrdersGridContextProvider>
      <FiltersBar>
        <div className={styles.filtersContainer}>
          <div className={styles.filters}>
            <FieldDateRange/>
            <FieldTextSearch/>
          </div>
          <div className={styles.buttonDownloadDesktop}>
            <ButtonDownload/>
          </div>
        </div>
      </FiltersBar>
      <div className={styles.statsPanelContainer}>
        <StatsPanel/>
        <div className={styles.buttonDownloadMobile}>
          <ButtonDownload/>
        </div>
      </div>
      <InvoiceOrdersGrid/>
      <FooterDivider/>
      <FooterLogo/>
    </InvoiceOrdersGridContextProvider>
  );
};

export default InvoiceOrders;
